export default "__VITE_ASSET__BoBHbAUj__"